module.exports = __webpack_public_path__ + "img/doc.8ff75b36.svg";